import create from 'utilities/zustand/create';

export const useObjectViewerStore = create(() => ({
  productContents: [],
}));
